<template>
  <div class="content content--solution-single">
    <OverlayLoader v-if="!$store.getters.solutionLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="breadcrumbItems"/>

    <header class="content-header d-lg-none">
      <h1 v-html="solution.headline"></h1>
    </header>

    <div class="hero--solution">
      <div class="container">
        <div class="hero-top">
          <div class="hero-pic">
            <ImageWrapper :file="solution.idFile" :key="solution.idFile"></ImageWrapper>
            <VideoWrapper v-if="solution.videoURL" :videoLink="solution.videoURL" :withoutPlayButton="true"></VideoWrapper>
          </div>
          <div class="hero-content" v-if="$store.getters.solutionLoaded">
            <div class="hero-content-top">
              <Bookmark :contentId="solution.idContent"></Bookmark>
              <span class="box-tag">
                <span v-if="solutionCategories && solutionCategories.parent && solutionCategories.parent.name">{{ solutionCategories.parent.name }}</span>
                <span v-if="solutionCategories && solutionCategories.child && solutionCategories.child.name">{{ solutionCategories.child.name }}</span>
                <span v-if="contentType && contentType.value">{{contentType.value}}</span>
                <span>{{readTime(solution.contentSolution)}} minute read</span>
              </span>
            </div>
            <span class="box-title">{{ solution.headline }}</span>
            <div class="buttons">
              <a v-if="solution.email" @click="openPopup($event, 'popupRequest')" class="button">Request contact</a>
              <a v-if="solution._embedded.Content.shareEnabled" @click="openPopup($event, 'popupShare')" class="button">Share with client</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs">
      <div class="tabs-inner">
        <template v-if="$store.getters.dynamicSolution">
          <router-link :to="{name: solutionRoute}" exact active-class="active">Main information</router-link>
          <router-link v-if="$store.getters.solutionAssets.length" to="assets" active-class="active">Assets</router-link>
          <router-link v-if="$store.getters.solutionContacts.length" to="contacts" active-class="active">Contacts</router-link>
        </template>
        <template v-else>
          <router-link :to="{name: solutionRoute}"  class="active">Main information</router-link>
        </template>
      </div>
    </div>

    <router-view></router-view>

    <transition name="fade">
      <PopupRequestContact v-if="popupRequest" :data="{ message: {
        content: '',
        subject: `Request contact - ${solution.headline}`,
        topic: ''
      }, email: solution.email}" @closePopup="closePopup()" />
    </transition>
    <transition name="fade">
      <PopupShareByEmail v-if="popupShare" :data="{ message: {
        content: solution._embedded.Content.shareContent,
        subject: `Request contact - ${solution.headline}`,
        topic: ''
      }}" @closePopup="closePopup()" />
    </transition>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";
import ImageWrapper from "@/components/general/ImageWrapper";
import {slugify} from "@/helpers/slugify";
import {readTime} from "@/helpers/readTime";
import PopupRequestContact from "@/components/general/PopupRequestContact";
import settings from "@/settings";
import Bookmark from "@/components/general/Bookmark";
import VideoWrapper from "@/components/general/VideoWrapper";
import PopupShareByEmail from "@/components/solutions/PopupShareByEmail";
import userApi from "@/api/user";

export default {
  name: "Solution",
  components: {PopupShareByEmail, VideoWrapper, Bookmark, PopupRequestContact, ImageWrapper, OverlayLoader, MyHeader },
  data() {
    return {
      popupRequest: false,
      popupShare: false,
    }
  },
  watch: {
    '$route.params.id'() {
      this.$store.dispatch('cleanSolution')
      this.$store.dispatch('getSolution', this.$route.params.id)
    },
    '$store.getters.solutionLoaded' (val) {
      if(val) {
        window._paq.push(['setDocumentTitle', this.$store.getters.solution.headline + ' | ' + 'Main information']);
        window._paq.push(['trackPageView']);
        userApi.logUserAccessContent({
          "idContent": this.solution.idContent,
          "idUser": this.$store.getters.user.idUser,
          "idUserAccessContent":""
        })
      }
    },
  },
  computed: {
    solutionRoute() {
      // return this.$route.name
      if(['SolutionProcess', 'SolutionProcessContacts', 'SolutionProcessAssets'].includes(this.$route.name)) {
        return 'SolutionProcess'
      }
      if(['SolutionMain', 'SolutionContacts', 'SolutionAssets'].includes(this.$route.name)) {
        return 'SolutionMain'
      }
      if(['SolutionProcessSingle', 'SolutionProcessContactsSingle', 'SolutionProcessAssetsSingle'].includes(this.$route.name)) {
        return 'SolutionProcessSingle'
      }
      return 'SolutionMain'
    },
    breadcrumbItems() {
      if(this.$route.path.startsWith(`/${this.$route.params.companySlug}/solutions/`)) {
        if(this.section && this.section.value) {
          return [
            {
              name: this.section.value,
              path: `/${this.$route.params.companySlug}/solutions/${slugify(this.section.value)}`
            },
            {
              name: this.solution.headline,
              path: this.$route.path
            },
          ]
        }
        return [
          {
            name: this.solution.headline,
            path: this.$route.path
          },
        ]
      }
      let items = []
      if(this.section && this.section.value) {
        items.push({
          name: this.section.value,
            path: `/${this.$route.params.companySlug}/page/${slugify(this.section.value)}`
        })
      }
      if(this.solutionCategories.parent && this.section.value) {
        items.push({
          name: this.solutionCategories.parent.name,
          path: `/${this.$route.params.companySlug}/page/${slugify(this.section.value)}?tab=${slugify(this.solutionCategories.parent.name)}`
        })
      }
      if(this.solutionCategories.parent && this.solutionCategories.child && this.section.value) {
        items.push( {
          name: this.solutionCategories.child.name,
          path: `/${this.$route.params.companySlug}/page/${slugify(this.section.value)}?tab=${slugify(this.solutionCategories.parent.name)}&subtab=${slugify(this.solutionCategories.child.name)}`
        })
      }
      items.push( {
        name: this.solution.headline,
        path: this.$route.path
      })
      return items
    },
    solution() {
      return this.$store.getters.solution
    },
    section() {
      if(this.$route.path.startsWith(`/${this.$route.params.companySlug}/solutions/`)) {
        return this.$store.getters.sectionByCodeAndSlug(settings.MODULES.SOLUTIONS, this.$route.params.slug)
      }
      return this.$store.getters.sectionByCodeAndSlug(settings.MODULES.SETTING_COMPANY_CONTENT, this.$route.params.slug)
    },
    solutionCategories() {
      if(!this.$route.path.startsWith(`/${this.$route.params.companySlug}/solutions/`)) {
        let categories = {};
        categories['parent'] = this.$store.getters.contentSection.find(item => {
          // eslint-disable-next-line no-prototype-builtins
          if(item.hasOwnProperty('subtabs')) {
            return item.subtabs.find(elem => {
              let solution = elem.solutions?.find(solution => {
                return solution.idSolution === this.$route.params.id
              })
              if(solution) {
                categories['child'] = elem
                return true
              }
            })
          }
          let solution = item.solutions?.find(solution => {
            return solution.idSolution === this.$route.params.id
          })
          return !!solution
        })
        return categories
      }
      return {};
    },
    contentType() {
      return this.$store.getters.settingsCompanyBySettingTypeCodeAndID(settings.SETTING_TYPES.SOLUTIONS_CONTENT_TYPES, this.solution.idContentType)
    }
  },
  methods: {
    slugify: slugify,
    readTime: readTime,
    trackOpenSolutionContact () {
      this.$gtag.event('OpenSolutionContact', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': this.$route.path,
        'value': this.solution.headline
      })
    },
    openPopup (e, popup) {
      e.preventDefault()
      this[popup] = true
      // this.trackOpenSolutionContact()
      document.querySelector('body').classList.add('nooverflow')
    },
    closePopup () {
      this.popupRequest = false
      this.popupShare = false
      document.querySelector('body').classList.remove('nooverflow')
    }
  },
  mounted() {
    this.$store.dispatch('getSolution', this.$route.params.id)
    if(this.section && this.section.idSettingCompany) {
      this.$store.dispatch('getContentSection', {id: this.section.idSettingCompany})
    }
  },
  beforeDestroy() {
    this.$store.dispatch('cleanSolution')
  }
}
</script>
